import React from 'react';
import { ChangePasswordComponent } from '../components/ChangePassword';

function ChangePassword() {
  return <ChangePasswordComponent />;
}

export { ChangePassword }